import React from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import Sidebar from "../Sidebar/Sidebar";
import GoalsBanner from "../../Goals/GoalsBanner";

const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
`;

const MainContent = styled.main`
  flex: 1;
  margin-left: 260px;
  min-height: 100vh;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
`;

const ContentWrapper = styled.div`
  padding: 24px 32px;
  max-width: 1600px;
  margin: 0 auto;
  width: 100%;
  flex: 1;

  @media (max-width: 1200px) {
    padding: 20px 24px;
  }
`;

function MainLayout() {
  return (
    <LayoutContainer>
      <Sidebar />
      <MainContent>
        <GoalsBanner />
        <ContentWrapper>
          <Outlet />
        </ContentWrapper>
      </MainContent>
    </LayoutContainer>
  );
}

export default MainLayout;

